import axiosClient from './axiosClient'; // main client
const API_BASE = '/auth'; // appended to axiosClient baseURL

// ---------------------------
// LOGIN (with cancellation support)
// ---------------------------
export const loginUser = async (payload, signal) => {
  try {
    const res = await axiosClient.post(
      `${API_BASE}/login.php`,
      payload,
      signal ? { signal } : undefined
    );
    return res.data; // { status, access_token, refresh_token, user }
  } catch (err) {
    // ✅ Ignore cancelled requests (professional behavior)
    if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') {
      return;
    }
    console.error('❌ [loginUser] Error:', err);
    throw err;
  }
};

// ---------------------------
// REGISTER (optional cancellation)
// ---------------------------
export const registerUser = async (payload, signal) => {
  try {
    const res = await axiosClient.post(
      `${API_BASE}/register.php`,
      payload,
      signal ? { signal } : undefined
    );
    return res.data; // { status, message }
  } catch (err) {
    if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') {
      return;
    }
    console.error('❌ [registerUser] Error:', err);
    throw err;
  }
};

// ---------------------------
// REFRESH TOKEN
// ---------------------------
export const refreshTokenApi = async (refresh_token) => {
  try {
    const res = await axiosClient.post(
      `${API_BASE}/refresh_token.php`,
      { refresh_token }
    );
    return res.data;
  } catch (err) {
    console.error('❌ [refreshTokenApi] Error:', err);
    throw err;
  }
};

// ---------------------------
// LOGOUT
// ---------------------------
export const logoutApi = async () => {
  try {
    const res = await axiosClient.post(`${API_BASE}/logout.php`);
    return res.data;
  } catch (err) {
    console.warn('⚠️ [logoutApi] Error (ignored):', err);
    return null;
  }
};

// ✅ Named export object (ESLint-safe)
const authApi = {
  loginUser,
  registerUser,
  refreshTokenApi,
  logoutApi,
};

export default authApi;
